import React, { useEffect, useState } from "react";
import Container from "../../../components/Container";
import { BtnPadrao, BtnDeletar, BtnEdit, ModalPadrao, LabelPadrao, InputPadrao, CheckBoxPadrao, LoadingContainerPadrao, BtnIncluir } from "../../../components/Base";
import { Divider } from "antd";
import TabelaPadrao from "../../../components/TabelaPadrao";
import * as api from "./api";
import { useFetch, useSave } from "../../../components/Hooks/Conexao";
import Mensagens from "../../../components/Mensagens";
import { connect } from "react-redux";
import { logIn, fetch } from "../../../actions/index";

function Fabricantes(props) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [detalhe, setDetalhe] = useState(null);

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
    },
    {
      Header: " ",
      accessor: "idFabricante",
      tipo: "right",
      Cell: data => {
        const row = data.row.original.idFabricante;
        return (
          <div>
            <BtnEdit style={{ marginRight: 10 }} onClick={() => setDetalhe(row)} />
            <BtnDeletar
              onOk={() =>
                listarDados(
                  () => api.deletar(props.fetch, row),
                  () => {
                    const aux = [...dados];
                    aux.splice(
                      dados.findIndex(x => x.idFabricante === row),
                      1
                    );
                    setDados(aux);
                    Mensagens.showSucesso("Usuário deletado com sucesso!");
                  }
                )
              }
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    listarDados(() => api.getAll(props.fetch));
  }, []);

  function onOk(v) {
    const aux = [...dados];

    const regInx = aux.findIndex(x => x.idFabricante === v.idFabricante);

    if (aux.findIndex(x => x.idFabricante === v.idFabricante) !== -1) {
      aux[regInx] = v;
    } else {
      aux.push(v);
    }
    setDados(aux);
    setDetalhe(null);
  }

  return (
    <>
      <Container loading={loading}>
        <div>
          <Divider orientation="left">Fabricante</Divider>
          <BtnIncluir type="primary" onClick={() => setDetalhe(-1)} ghost />
        </div>
        <TabelaPadrao columns={columns} data={dados} style={{ margin: "25px 0" }} />
        {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
      </Container>
      <ModalInserir fetch={props.fetch} onCancel={() => setDetalhe(null)} onOk={onOk} id={detalhe} />
    </>
  );
}
export default connect(null, { logIn, fetch })(Fabricantes);

function ModalInserir({ id, onOk, onCancel, fetch, ...props }) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [save, saving] = useSave(
    () => api.post(fetch, dados),
    v => {
      if (v) onOk({ ...dados, idFabricante: v });
      else onOk(dados);
      Mensagens.showSucesso("Dados salvos com sucesso!");
    }
  );

  function onSave() {
    if (!dados.nome) {
      Mensagens.showErro("Dados não preenchidos!");
      return;
    }
    save();
  }

  useEffect(() => {
    if (id) listarDados(() => api.getDetalhe(fetch, id));
  }, [id]);

  return (
    <ModalPadrao
      visible={id}
      onCancel={onCancel}
      title="Fabricante"
      footer={
        <>
          <BtnPadrao type="primary" onClick={onSave} loading={saving}>
            Gravar
          </BtnPadrao>
          <BtnPadrao type="primary" onClick={onCancel} ghost>
            Sair
          </BtnPadrao>
        </>
      }
    >
      <LoadingContainerPadrao loading={loading}>
        <div>
          <LabelPadrao noMargin>Nome</LabelPadrao>
          <InputPadrao value={(dados || []).nome} onChange={v => setDados({ ...dados, nome: v.target.value })} autoFocus />
          <LabelPadrao>Variações</LabelPadrao>
          <InputPadrao value={(dados || []).variacoes} placeholder="ex: Fabricante 01,Fabricante 02..." onChange={v => setDados({ ...dados, variacoes: v.target.value })} />
          <LabelPadrao>Exceções</LabelPadrao>
          <InputPadrao value={(dados || []).excecoes} placeholder="ex: Fabricante 01,Fabricante 02..." onChange={v => setDados({ ...dados, excecoes: v.target.value })} />
          <LabelPadrao>Exceções no nome do produto</LabelPadrao>
          <InputPadrao value={(dados || []).excecoesProd} placeholder="ex: Produto 01,Produto 02..." onChange={v => setDados({ ...dados, excecoesProd: v.target.value })} />
        </div>
      </LoadingContainerPadrao>
      {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
    </ModalPadrao>
  );
}
